import React, { useState } from "react";

export default function Profile({ user, handleEditButton }) {

    const formatDate = (inputDate) => {
        const dateParts = inputDate.split('-'); // Split the input date into an array of parts
        const formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`; // Rearrange the parts
        return formattedDate
    }

  return (
    <div id="account_general">
      <div id="userDetails_container">
        <h3>My Profile</h3>
        <div id="account_details_row">
          <div id="account_firstName">
            <h5>First Name</h5>

            <div id="account_row_group">
              <p>{user.firstName}</p>
            </div>
          </div>

          <div id="account_lastName">
            <h5>Last Name</h5>

            <div id="account_row_group">
              <p>{user.lastName}</p>
            </div>
          </div>
        </div>

        <div id="account_details_row">
          <div id="account_userName">
            <h5>User Name</h5>
            <div id="account_row_group">
              <p>{user.userName}</p>
            </div>
          </div>

          <div id="account_email">
            <h5>Email</h5>
            <div id="account_row_group">
              <p>{user.email}</p>
            </div>
          </div>
        </div>

        <div id="account_details_row">
          <div id="account_location">
            <h5>Location</h5>
            <div id="account_row_group">
              <p>{user.location}</p>
            </div>
          </div>

          <div id="account_birth">
            <h5>Date of Birth</h5>
            <div id="account_row_group">
              <p>{formatDate(user.birthDate)}</p>
            </div>
          </div>
        </div>

        <div id="account_details_row">
          <div id="account_avatar">
            <h5>Avatar</h5>
            <div id="account_row_group">
              <img
                id="account_picture"
                src={user.avatar}
                alt="profile picture"
              />
            </div>
          </div>

          <div id="account_newsletter">
            <h5>Newsletter</h5>
            <div id="account_row_group">
              {user.newsletter? 
                    <p>You are subscribed to the newsletter</p>
                :  
                    <p>You aren't subscribed to the newsletter</p>
              }
            </div>
          </div>
        </div>

        <div id="account_button_container">
          <button id="account_button" onClick={handleEditButton}>
            Edit Profile
          </button>
        </div>
      </div>
    </div>
  )
}
